import type { SubmissionErrors, TransitionErrors } from '../types/error';

export class SubmissionError extends Error {
  private readonly _errors: SubmissionErrors;

  constructor(errors: SubmissionErrors) {
    super('Submit Validation Failed');
    this._errors = errors;
  }

  public get errors(): SubmissionErrors {
    return this._errors;
  }
}

export class TransitionError extends Error {
  private readonly _errors: TransitionErrors;

  constructor(errors: TransitionErrors) {
    super('Transition blocked');
    this._errors = errors;
  }

  public get errors(): TransitionErrors {
    return this._errors;
  }

  public get blockers(): string {
    return Object.keys(this.errors)
      .filter((error) => error.startsWith('blocker-'))
      .map((error) => this.errors[error])
      .join(', ');
  }
}
